import { HTTP } from "./http";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-trials.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-trials.php";
}

const Trials = {
  // Public
  getPublicConfig(clubId) {
    return HTTP.post(API_SERVER, { action: "getPublicTrialsConfig", clubId });
  },
  submit(payload) {
    return HTTP.post(API_SERVER, { action: "submitTrialRegistration", ...payload });
  },
  /** Public, signed: what the "pay your deposit" page shows. */
  getDeposit(clubId, id, t) {
    return HTTP.post(API_SERVER, { action: "getTrialDeposit", clubId, id, t });
  },

  // Admin
  list(clubId) {
    return HTTP.post(API_SERVER, { action: "listTrialRegistrations", clubId });
  },
  update(clubId, id, changes) {
    return HTTP.post(API_SERVER, {
      action: "updateTrialRegistration",
      clubId,
      id,
      ...changes,
    });
  },
  /** Remove a duplicate registration (refused for rows that joined or paid). */
  remove(clubId, id) {
    return HTTP.post(API_SERVER, { action: "deleteTrialRegistration", clubId, id });
  },
  /** Email the family the registration link and mark the row as invited. */
  sendSignupLink(clubId, id, offeredTeam) {
    return HTTP.post(API_SERVER, { action: "sendTrialSignupLink", clubId, id, offeredTeam });
  },
  /** Email the family of a Declined registration that no place is offered. */
  sendDeclineEmail(clubId, id) {
    return HTTP.post(API_SERVER, { action: "sendTrialDeclineEmail", clubId, id });
  },
  /** Stamp a trial row as converted once its invite link produced a sign-up. */
  linkRegistration(clubId, id, t, userId) {
    return HTTP.post(API_SERVER, {
      action: "linkTrialRegistration",
      clubId,
      id,
      t,
      userId,
    });
  },
  setOpen(clubId, open) {
    return HTTP.post(API_SERVER, { action: "setTrialsOpen", clubId, open });
  },
  getConfig(clubId) {
    return HTTP.post(API_SERVER, { action: "getTrialsConfig", clubId });
  },
  saveConfig(clubId, config) {
    return HTTP.post(API_SERVER, { action: "saveTrialsConfig", clubId, config });
  },
};

export { Trials };
